import { render, staticRenderFns } from "./CompareFile.vue?vue&type=template&id=204efc37"
import script from "./CompareFile.vue?vue&type=script&lang=js"
export * from "./CompareFile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports